import { Api as API } from '../../config/apiCallDispatcher';
import { CreateParentConsentPayload } from './types';

export const createParentConsent = async (payload: CreateParentConsentPayload) => {
    const result = await API.post('partners-write', 'camhs-parent-consent', payload);
    return result;
};
